/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useDeferredValue, useRef } from "react";
import { IView, TViewComponent } from "../../../view/IView";
import { TViewFetcher } from "./getViewFetcher";

export interface IViewDisplayProps {
	ViewComponent: TViewComponent<IView<unknown>>;
	viewFetcher: TViewFetcher;
}

export const ViewDisplay = React.memo<IViewDisplayProps>(({ ViewComponent, viewFetcher }) => {
	const view = viewFetcher.read();
	const defView = useDeferredValue(view);
	const lastKey = useRef(0);

	if (defView !== view) {
		lastKey.current = lastKey.current + 1;
	}

	return <ViewComponent key={String(lastKey?.current)} view={view} />;
});

ViewDisplay.displayName = "ViewDisplay";
